import { moduleNames } from "@lib/appconst"
import fileService from "@services/common/fileService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import floorStaffService from "@services/floorStaff/floorStaffService"
import { action, makeAutoObservable, observable } from "mobx"

class FloorStaffStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable tabOpportunityTableData!: PagedResultDto<any>
  @observable tabCustomerTableData!: PagedResultDto<any>
  @observable tabBussinessTableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable userExistsByPhone!: any
  @observable userExistsByUsername!: any
  @observable userExistsByEmail!: any
  @observable listFloor!: any[]
  @observable auditLogData!: any
  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.tabOpportunityTableData = { items: [], totalCount: 0 }
    this.tabCustomerTableData = { items: [], totalCount: 0 }
    this.tabBussinessTableData = { items: [], totalCount: 0 }
    this.detailData = {}
    this.userExistsByPhone = { id: 0, uniqueId: null, isActive: true }
    this.userExistsByUsername = { id: 0, uniqueId: null, isActive: true }
    this.userExistsByEmail = { id: 0, uniqueId: null, isActive: true }
    this.listFloor = []
    this.auditLogData = {}
  }

  @action
  async createOrUpdate(body: any, files?: any) {
    if (!body.id) {
      const result = await floorStaffService.create(body)
      const { uniqueId } = result
      if (files && files.length && uniqueId) {
        // Đợi tất cả file upload xong
        await Promise.all(
          files.map(async (file) => {
            if (file.originFileObj !== undefined) {
              const fileUpload = file.originFileObj
              await fileService.upload(
                moduleNames.customerAvatar,
                uniqueId,
                fileUpload
              )
            }
          })
        )
      }
      this.detailData = result
      this.tableData.items.push(result)
    } else {
      const result = await floorStaffService.update(body)
      const { uniqueId } = result
      if (files && files.length && uniqueId) {
        // Đợi tất cả file upload xong
        await Promise.all(
          files.map(async (file) => {
            if (file.originFileObj !== undefined) {
              const fileUpload = file.originFileObj
              await fileService.upload(
                moduleNames.customerAvatar,
                uniqueId,
                fileUpload
              )
            }
          })
        )
      }
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }

  @action
  async init() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async activateOrDeactivate(id: number, active: boolean) {
    await floorStaffService.activateOrDeactivate(id, active)
  }
  @action
  async bulkActive(id: number[]) {
    await floorStaffService.bulkActive(id)
  }
  @action
  async get(id: number) {
    const result = await floorStaffService.get(id)
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await floorStaffService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async getAllOpportunityById(params: any) {
    this.isLoading = true
    this.tabOpportunityTableData = await floorStaffService
      .getAllOpportunityById(params)
      .finally(() => (this.isLoading = false))
  }

  @action
  async getAllCustomerById(params: any) {
    this.isLoading = true
    this.tabCustomerTableData = await floorStaffService
      .getAllCustomerById(params)
      .finally(() => (this.isLoading = false))
  }

  @action
  async getAllBussinessById(params: any) {
    // this.isLoading = true;
    // this.tabCustomerTableData = await floorStaffService
    //   .getAllCustomerById(params)
    //   .finally(() => (this.isLoading = false));
  }

  @action
  async getExistPhone(input: string) {
    const result = await floorStaffService.getExistPhone(input)
    this.userExistsByPhone = result
    return result
  }

  @action
  async getExistUsername(input: string) {
    const result = await floorStaffService.getExistUsername(input)
    this.userExistsByUsername = result
    return result
  }

  @action
  async getExistEmail(input: string) {
    const result = await floorStaffService.getExistEmail(input)
    this.userExistsByEmail = result
    return result
  }

  @action
  async getListFloor() {
    this.isLoading = true
    const res = await floorStaffService
      .getListFloor()
      .finally(() => (this.isLoading = false))
    this.listFloor = res
    return res
  }
  @action
  async getAuditLogs(id: number) {
    const result = await floorStaffService.getAuditLogs(id)
    this.auditLogData = result
    return result
  }
}

export default FloorStaffStore
